<template>
  <v-dialog v-model="showConfirmLeave" persistent max-width="350">
    <v-card>
      <v-card-title>Leave</v-card-title>
      <v-divider/>
      <v-card-text class="mt-4">You have unsaved changes that will be lost. Are you sure you want to leave?".</v-card-text>
      <v-divider/>
      <v-card-actions class="pr-6">
        <v-spacer></v-spacer>
        <v-btn plain color="primary" @click="performLeave(true)">Yes</v-btn>
        <v-btn color="primary" @click="performLeave(false)">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: 'ConfirmLeave',
	props: {
    value: {type:Function,required:false},
  },
  data() {
    return {
      showConfirmLeave: false,
      next: null,
    }
  },
  watch: {
    value() {
      this.next = this.value;
      if (this.next)
        this.showConfirmLeave = true;
    }
  },
  methods: {
    async performLeave(leave) {
      this.showConfirmLeave = false;
      try {
        await this.next(leave);
      // eslint-disable-next-line no-empty
      } catch (error) {
      }
    },
  }
}
</script>